/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Intro_InfoInputs */



/**
* | output |
* | --- |
* | "For each colleague you see where you stand, based on your previous conversations. Does it say \"No conversation info yet\"? Turn on the notetaker for your 1:1,..." |
*
* @param {Team_Intro_InfoInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_intro_info = /** @type {((inputs?: Team_Intro_InfoInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Intro_InfoInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Per collega zie je waar jullie staan, op basis van jullie vorige gesprekken. Staat er \"Nog geen gespreksinfo\"? Zet de notetaker aan voor jullie 1:1, of voeg achteraf zelf notities toe.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pour chaque collègue, vous voyez où vous en êtes ensemble, d'après vos entretiens précédents. Vous voyez « Pas encore d'infos d'entretien » ? Activez le notetaker pour ce one-to-one, ou ajoutez vos propres notes après coup.")
	return /** @type {LocalizedString} */ ("For each colleague you see where you stand, based on your previous conversations. Does it say \"No conversation info yet\"? Turn on the notetaker for your 1:1, or add your own notes afterwards.")
});